import loadScript from 'load-script';
import defined from '~app/core/defined';

export function loadApiScript(url) {
  return new Promise(function (resolve, reject) {
    loadScript(url, function (err, script) {
      if (err !== null) return reject(err);
      resolve(script);
    });
  });
}

export function loadLibs() {
  return new Promise(function (resolve, reject) {
    window.gapi.load('client:auth2', resolve);
  });
}

export function initClient() {
  return window.gapi.client.init({
    clientId: process.env.GOOGLE_DRIVE_API_CLIENT_ID,
    discoveryDocs: [process.env.GOOGLE_DRIVE_API_DISCOVERY_DOCS],
    scope: process.env.GOOGLE_DRIVE_API_SCOPES,
  });
}

export function signIn() {
  return window.gapi.auth2.getAuthInstance().signIn();
}

export async function getFileByName(fileName) {
  const args = {
    fields: 'files(id, name, description)',
    q: `name = '${fileName}'`,
    spaces: 'appDataFolder',
  };
  const { result } = await window.gapi.client.drive.files.list(args);
  if (result.files.length > 0) {
    return result.files[0];
  }
}

export function listFiles(nextPageToken) {
  const args = {
    pageSize: 6,
    fields: 'nextPageToken, files(id, name, description)',
    spaces: 'appDataFolder',
  };
  if (nextPageToken) args.pageToken = nextPageToken;
  return window.gapi.client.drive.files.list(args);
}

export function load(fileId) {
  return window.gapi.client.drive.files.get({ fileId, alt: 'media' });
}

export function save(data, { fileName, contentType, description }) {
  if (!contentType) contentType = 'application/json; charset=UTF8';
  const boundary = '-------314159265358979323846';
  const delimiter = '\r\n--' + boundary + '\r\n';
  const close_delim = '\r\n--' + boundary + '--';
  const metadata = {
    name: fileName,
    mimeType: contentType,
    parents: ['appDataFolder'],
  };
  if (defined(description)) metadata.description = description;

  const multipartRequestBody =
    delimiter +
    'Content-Type: application/json\r\n\r\n' +
    JSON.stringify(metadata) +
    delimiter +
    'Content-Type: ' +
    contentType +
    '\r\n\r\n' +
    data +
    close_delim;

  return window.gapi.client.request({
    path: process.env.GOOGLE_DRIVE_UPLOAD_PATH,
    method: 'POST',
    params: {
      uploadType: 'multipart',
    },
    headers: {
      'Content-Type': 'multipart/related; boundary="' + boundary + '"',
    },
    body: multipartRequestBody,
  });
}

export function deleteFile(fileId) {
  return window.gapi.client.request({
    path: `https://www.googleapis.com/drive/v3/files/${fileId}`,
    method: 'DELETE',
  });
}
